import { BACKEND_BASE_URL } from "../config/app.config";
import { httpGet } from "./http.service";

const URL = `${BACKEND_BASE_URL}/api/financials`;

const getFinancialData = async (queryParams: any) => {
  try {
    const response = await httpGet(`${URL}?${queryParams}`);
    const data = response?.data;
    return data;
  } catch (error: any) {
    throw error?.data?.error;
  }
};

export { getFinancialData };
